import formatDate from './format-date';

export { formatDate };

export default formatDate;
